import type { IValidatedResponse } from '../../../httpClient';
import { putRequest } from '../../../httpClient';
import type { IUpdateSubscriptionRequest } from './update-subscription-request';
import type { IUpdateSubscriptionResponse } from './update-subscription-response';
import { updateSubscriptionResponseSchema } from './update-subscription-response';

export async function updateAdminSubscriptionApi(
  subscriptionId: string,
  body: IUpdateSubscriptionRequest,
): Promise<IValidatedResponse<IUpdateSubscriptionResponse>> {
  return putRequest<IUpdateSubscriptionResponse>({
    path: `/sys/billing/subscriptions/${subscriptionId}`,
    schema: updateSubscriptionResponseSchema,
    body,
  });
}
